import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import { _GetCustomAttributesForPage } from "@discovery/sonic-api-ng-optics";
import { boolean, optional, record, } from "@discovery/prelude/lib/data/validated";
import * as M from "@discovery/prelude/lib/data/maybe";
export const _Page = Fold.compose(Optics._RouteResponse2Route, Optics._Route2Page);
export const _Page2TxNodeAttr = Fold.compose(_Page, Res._RelAssoc("primaryContent", "taxonomyNode"), Optics._TxNode2Attributes);
export const _Page2PageAttr = Fold.compose(_Page, Res._Response(), Fold.liftM((id, nameM, titleM, aliasM, templateIdM) => ({
    id,
    nameM,
    titleM,
    aliasM,
    templateIdM,
}), Lens.prop("id"), Lens.path("attributes", "name"), Lens.path("attributes", "pageMetadataTitle"), Lens.path("attributes", "alias"), Lens.path("attributes", "component")));
const customAttrValidator = optional(record({
    isKidsPage: boolean,
}));
export const _Page2CustomAttribute = Fold.compose(_Page, _GetCustomAttributesForPage(customAttrValidator), M._Just(), Lens.prop("isKidsPage"));
export const _PageTitle = Fold.compose(_Page, Res._Response(), Lens.path("attributes", "pageMetadataTitle"), M._Just());
